import React from "react";
import { UnfilledYellowButton } from "../buttons";
import { emptyFunction } from "../utilities";


const ToggleSignInSignUp = ({ text, buttonText, hashPath, onClick }) => (
  <div>
    <div
      className="w-90 t-center t-pb3"
      style={{ borderTop: "1px solid #d8d8d8" }}
    />
    <div className="flex justify-between items-center w-90 t-center ">
      <div className="gray-2 a-font-size-2 mw4 tl">
        <p>{text}</p>
      </div>
      <div className="">
        <UnfilledYellowButton
          className="px3 py1"
          text={buttonText}
          path={`#${hashPath}`}
          onClick={onClick}
        />
      </div>
    </div>
  </div>
);

ToggleSignInSignUp.defaultProps={
  onClick: emptyFunction
}

export default ToggleSignInSignUp;
